import clsx from 'clsx';
import Image from 'next/image';
import LazyLoad from 'react-lazyload';
import { Box, Container, Typography } from '@mui/material';
import { useStyles } from './styles';

export default function HowItWork() {
  const classes = useStyles();

  return (
    <Box bgcolor="#7833FF" py={6.25} px={20.62}>
      <Container>
        <LazyLoad>
          <Typography className={classes.title}>How does it work?</Typography>

          <Box display="flex" gap="40px">
            <Box display="flex" alignItems="center">
              <Image
                src="/images/custom-services/work-3-images.png"
                alt="work images"
                width={609}
                height={442}
                loading="lazy"
                responsive
              />
            </Box>

            <Box className={classes.mainBox}>
              <Box className={classes.steps}>
                <Typography className={clsx(classes.numberStep, classes.verticalDivider)}>
                  1
                </Typography>

                <Typography className={classes.textStep}>
                  Choose the <span>type of service</span> you want and request a design
                </Typography>
              </Box>

              <Box className={classes.steps} pt={4}>
                <Typography className={clsx(classes.numberStep, classes.verticalDivider)}>
                  2
                </Typography>

                <Typography className={classes.textStep}>
                  You&apos;ll receive <span>an e-mail</span> requesting some information that our
                  team needs in order to start working on your design
                </Typography>
              </Box>

              <Box className={classes.steps} pt={4}>
                <Typography className={clsx(classes.numberStep, classes.verticalDivider)}>
                  3
                </Typography>

                <Typography className={classes.textStep}>
                  Our team will work on it and deliver the first version in a maximum of{' '}
                  <span>5 business days</span>
                </Typography>
              </Box>

              <Box className={classes.steps} pt={4} pb={2}>
                <Typography className={classes.numberStep}>4</Typography>

                <Typography className={classes.textStep}>
                  If needed, you can request changes up to <span>3 times</span>
                </Typography>
              </Box>

              <Typography className={classes.textStep}>
                *For every change, our team requires 3 business days to deliver <br />
                ** If the author provides a sketch, the first draft delivery time can be shortened
                by 2 working days.
              </Typography>
            </Box>
          </Box>
        </LazyLoad>
      </Container>
    </Box>
  );
}
